import React from 'react'
import PropTypes from 'prop-types'
// import Button from "ui-coopeuch-button";

import styles from './style.scss'

const CardBase = (props) => {
  const {
    children,
    title,
    subtitle,
    actionButton,
    shadedOutline,
    noPadding,
    sizeTitle,
    intereactionDisabled
  } = props

  return (
    <section className={styles[`CardBase`]}>
      {/* ${shadedOutline ? ' CardBase--shaded' : ''}
        ${actionButton ? ' CardBase--action-button' : ''}
        ${intereactionDisabled ? ' CardBase--disabled' : ''} */}

      <header>
        {title && !sizeTitle && <h2>{title}</h2>}
        {title && sizeTitle && (
          <h2 className={styles[`CardBase__title--${sizeTitle}`]}>{title}</h2>
        )}
        {subtitle && <h4>{subtitle}</h4>}
        {actionButton && Object.keys(actionButton).length > 0 && (
          <button
            onClick={actionButton.onClickActionButton}
            disabled={actionButton.disabled}
          >
            {actionButton.icon}
            <span>{actionButton.label}</span>
          </button>
        )}
      </header>
      {children && <hr />}
      {children && (
        <article
          className={
            styles[`CardBase_content${noPadding ? '--no-padding' : ''}`]
          }
        >
          {children}
        </article>
      )}
    </section>
  )
}

CardBase.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  actionButton: PropTypes.object,
  shadedOutline: PropTypes.bool,
  noPadding: PropTypes.bool,
  intereactionDisabled: PropTypes.bool
}

export default CardBase
